module.exports = __webpack_public_path__ + "img/EGY.f1a6a5ee.svg";